export default __webpack_public_path__ + "static/media/monthly_horoscope_2021.6471e324.jpg";